<template>
  <div class="header">
    <div class="tab flex1 fx-j-c">
      <div style="width: 400px"></div>
      <div class="tab flex1 fx-j-c">
        <div
            class="opt pointer fx-aj-c"
            :class="{ b: tabPath === o.path }"
            v-for="(o, i) in tabList"
            :key="i"
            @click="tabChange(o)"
        >
          <template v-if="o.path === '/whatsapp'">
            <template v-if="waIsLogin">
              <el-badge :value="waBadgeCount" :hidden="waBadgeCount === 0" class="wa-tab-badge">
                <img v-if="tabPath === o.path" :src="o.src"/>
                <img v-else :src="o.srcb"/>
              </el-badge>
            </template>
            <template v-else>
              <img v-if="tabPath === o.path" :src="o.src"/>
              <img v-else :src="o.srcb"/>
            </template>
          </template>
          <template v-else-if="o.path === '/email'">
            <el-badge is-dot :hidden="!emailBadgeDotVisible" class="email-tab-badge">
              <img v-if="tabPath === o.path" :src="o.src"/>
              <img v-else :src="o.srcb"/>
            </el-badge>
          </template>
          <template v-else>
            <img v-if="tabPath === o.path" :src="o.src"/>
            <img v-else :src="o.srcb"/>
          </template>
        </div>
      </div>
      <div class="fx-j-e" style="width: 410px;align-items: center">
        <div
            class="dropdown-trigger"
            style="margin-right: 20px; position: relative;cursor: pointer"
            @click="drawer = true"
        >
          <img
              style="height: 35px; width: 35px"
              data-v-2b3b0c9a=""
              src="@/assets/chat.png"
              class="icon"
          />
          <span
              data-v-2b3b0c9a=""
              class="ant-badge"
              style="zoom: 0.8; position: absolute; top: 25px"
          ><a data-v-2b3b0c9a="" href="#"></a
          ><!----></span
          >
        </div>
        <!--        <div class="dropdown" style="cursor: pointer">-->
        <!--          <div class="dropdown-trigger"-->
        <!--               @click.stop="toggleDropdown"-->
        <!--               style="margin-right: 20px; position: relative">-->
        <!--            <img-->
        <!--                style="height: 35px; width: 35px"-->
        <!--                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAAXNSR0IArs4c6QAAAMZQTFRFAAAA////////////////////////9vb29/f39/f3+Pj49/f3+Pj49fX19vb29fX19vb29vb29vb29vb29vb29vb29vb29vb29fX19vb29fX19fX19vb29fX19fX19fX19vb29vb29vb29vb29fX19fX19fX19vb29vb2AAAAAgICBgYGDQ0NGBgYICAgLy8vRUVFTExMUlJSeXl5enp6hoaGiIiIlZWVo6Ojra2tvr6+x8fH1NTU4uLi5eXl7+/v9PT09fX1PL5yJAAAACl0Uk5TAAEGBwkSFBweHyc/RU1SaGxtcXKPkpOUnbG6u8XR0tXd3+Ll7O/x+f4CaWuJAAACVUlEQVRYw8WZaVvCMAzHKw482OS+YVAZwrxPPKZovv+XEp3gsTTtuvD4f7k++T3tmiZpKgStgltudn0ZTKeB9LvNslsQ9nK8+mAGfzQb1D3HhrZVbB+BQkft4lZK3HZpBKRGpe00a62OQatx1XjlngQjSc8It9cBY3V29byDCaTQ5ECDyzUgpRo5ipfvQ2r182rezhAsNNxR8fYPwUqH+4r5WfKWRHSO+SFYa4j8x1wfMqif3OsGZFIj4c+QUX88fG+SFTj5fQo7kFmdX/EFGPQj9jiSAyi/42MNWFRdx/sxD3C8ygolYFLpK7+NuICjOBcWgU3FT2BbNfzycHeL6O7hRWXR/vQZRT5/vj4OFTq+flZUAI7aqR9PQ0Knj2rnrqMjTychqZMn1Ky+BA6wgdfzUKPzV8xusKzXZtjAfajVPWY3KwgXnfqlHniJGrqign4/0wPPUMOyaKHfY4+5iN6SQ2/RRew7qGFL9NDv8SQi3DeieBQd6wmfAC5w4IIA+kISwDkOnBNAKQICGF7dJI/yzVVIAAMxpYCkUMMpP9B0yeuV0sAgxabMTYAyhdssTIB+CseOTIBdxdELE0dvdeK+wzZq2BRl211WBQfXFqgKX3iADe0DLJ4C9DxlCsCTlJZHJCnPBkilUTTR0zg60aOlyC0hXSnCXyyxl3PsBSd/SSyqzEU7/7WC/eLDfzXjvzyyX2/5L+D8LQL2JgZ/m4W/EcTfquJvpvG3+/gbkhtomfI3dT/iY82k7Vxz/q8xvoHW/QYeF9bPH5VWb/X80WtVtM8f7xamo1tP6vw2AAAAAElFTkSuQmCC"-->
        <!--                class="icon"-->
        <!--            />-->
        <!--          </div>-->
        <!--          <transition name="fade">-->
        <!--            <div class="dropdown-menu" v-show="visible">-->
        <!--              <Chat/>-->
        <!--            </div>-->
        <!--          </transition>-->
        <!--        </div>-->
        <!-- <el-dropdown trigger="click" :triggerKeys="[]"  style="margin-top: -3px !important;width: 60px;cursor: pointer">
          
          <template #dropdown>
            
          </template>
        </el-dropdown> -->
        <el-dropdown ref="dropdownRef" trigger="click" style="margin-top: -3px !important;width: 60px;cursor: pointer;">
          <div
              data-v-2b3b0c9a=""
              class="dropdown-trigger"
              style="margin-right: 20px; position: relative"
          >
            <img
                style="height: 35px; width: 35px"
                data-v-2b3b0c9a=""
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAAXNSR0IArs4c6QAAAVNQTFRFAAAA////////////////////////9vb29/f39/f3+Pj49/f3+Pj49fX19vb29fX19vb29vb29vb29vb29vb29vb29vb29vb29fX19vb29fX19fX19vb29fX19fX19fX19vb29vb29vb29vb29fX19fX19fX19vb29vb2AAAAAQEBAgICAwMDBAQEBQUFCwsLDg4ODw8PEBAQEhISExMTFxcXGBgYIiIiJSUlKCgoKysrLS0tMTExODg4OTk5PDw8QkJCSUlJSkpKS0tLTk5OUVFRV1dXWFhYX19fYWFhYmJiZGRkaGhobW1tc3Nzfn5+f39/gICAhoaGiIiIioqKj4+PmZmZp6enqampq6urrq6uubm5v7+/wcHBxsbGx8fHyMjIycnJy8vLzc3N0tLS1NTU29vb3t7e4ODg5OTk7e3t7+/v8PDw8fHx8vLy9PT09fX1MYtzuwAAACl0Uk5TAAEGBwkSFBweHyc/RU1SaGxtcXKPkpOUnbG6u8XR0tXd3+Ll7O/x+f4CaWuJAAAClUlEQVRYw8WZ6VvTQBDGl5IWIQ3pfR8Eei0g4oXifZ+oKOIt3goeMP//J0tLK7Q7szmmj+/XzP6ebDKZmX0jBK1INJYpVJxas1lzKoVMLBoR/mVYqXILBtQqpyzDD23MzDUAUSNnjnnEjdszQGrGHvey18QcaDWXcL1zywFXcixXuMk8uFb+mJ43XQcPqk9rcKE0eFQ6RPHCJfCsUhjnTVTBh6oTGG9qFnxpdgq5P5+8NlF5j+Eq+FZV8RxDJQig0vC7TkMgpYfyGQJqIMMn60GB9aNfYR4CK3+kvgCDDtUew+EAOv/qYxJYlOjXe019/rZx/dzy0sqltZe/6Rre6wo2Gfbx5rzsaeXpLyrUPuhvVD/ae3JcHtbqB6pzdXuhSfEeyAGdfEeEmx1gjohYl0M68wMPz3VypoEHfFkaBsrbeHzD0CT1QwVPLnynkztFAE+pgHITX5BqA8v45W0lTz7CV5Tb81qLSEE18C6+ohURUWLHW2rgHWJJVMR5gTGR5QVmRZEXWBQVXmBFOLxAR9R4gTXR5AU2+YHsW6Zeyms18Cr5Uoi02b2gBso3VNoQib2J8OR5vPsViE9v5zQGlBvoooyIodfWUJ5c3saLA1q+Pi/iQHkfL19ogb1G8OT8FlpgsRbwSpK6gbYArEk9poELu2iTsnzd4UW8jWKNfv0sjlu88hVv9OgosreD6ic1ipDDUlefnnX0Qhto6se5LrC70Vu6uINxTjNw7ute58G914XZLkdigD/PV09cfqu1NfpGSYJ5aOc/VrAffPiPZvyHR/bjLf8BnN8iYDcx+G0WfiOI36riN9P47T5+Q3IElim/qbtfH5NubOek8f+M8RFY9yP4udD//RHPFnu/P4rZuPb3x1/0Rpu322bkPAAAAABJRU5ErkJggg=="
                class="icon"
            />
            <el-badge :value="allDataTotal" v-show="allDataTotal!==0" class="items_message">
            </el-badge>
            <span
                data-v-2b3b0c9a=""
                class="ant-badge"
                style="zoom: 0.8; position: absolute; top: 25px"
            ><a data-v-2b3b0c9a="" href="#"></a
            ><!----></span
            >
          </div>

          <template #dropdown>
            <div class="boxs">
              <div class="tops_side">
                <div class="top_message">{{ $t('sys.notice.unreadas') }}</div>
                <el-button type="primary" :icon="Select" link
                           style="
                      font-family: PingFangSC, PingFang SC;
                  font-weight: 500;
                  font-size: 18px;"
                           @click="handleClickIsRead" :loading="isReadAllLoading">
                  {{ $t('common.cds41') }}
                </el-button>
              </div>
              <div class="inner_boxs">
                <div class="empty" style="padding-bottom: 60px" v-if="resultTargetDataList.length===0">
                  {{ $t('common.notice.nomore') }}
                </div>
                <!--here-->
                <template v-else>
                  <Message :resultTargetDataList="resultTargetDataList" @changePages="changePage"
                           @getUnReads="getUnReadsList" @closeDropdownRef="closeDropdownRef">
                    <template #loadings>
                      <div style="display: flex;justify-content: center;width: 100%;"
                           :loading="allNewDataIsLoading"></div>
                    </template>
                  </Message>
                </template>
                <div class="item_box">
                  <el-button link type="primary" style="padding: 12px 0px;font-size: 14px" @click="toAllNotify">
                    {{ $t('common.notice.viewall') }}
                  </el-button>
                </div>
              </div>
            </div>
          </template>
        </el-dropdown>
        <el-dropdown trigger="click" style="margin-top: -3px !important;cursor: pointer">
          <div data-v-2b3b0c9a="" class="dropdown-trigger">
            <el-avatar
                style="width: 35px !important;height: 35px !important;"
                v-if="userInfo.avatar"
                :src="userInfo.avatar"
            />
            <el-avatar class="header_avatar" v-else
            >
              <img style="height: 14px; width: 14px" :src="require('@/assets/default/avatar.png')"/>
            </el-avatar>
          </div>
          <template #dropdown>
            <div class="tops">
              <div>
                <el-avatar v-if="userInfo.avatar"
                           :src="userInfo.avatar"
                           :size="50"
                />
                <el-avatar v-else
                           :size="50"
                >
                  <img style="height: 25px; width: 25px" :src="require('@/assets/default/avatar.png')"/>
                </el-avatar>
              </div>
              <div class="username">{{ userInfo.userName }}</div>
              <div class="ids" v-if="userInfo.guid">ID:{{ userInfo.guid }}</div>
              <div>
                <el-button @click="goToUserCenter" type="primary" size="small" round plain
                >{{ $t('common.person.manageMyAccount') }}
                </el-button
                >
              </div>
            </div>
            <el-dropdown-menu>
              <!--              工位-->
              <el-dropdown-item v-if="isEnterpriseMainUser||isNormalUser" @click="goToStation">
                <div class="items">
                  <div class="left_text">
                    <span><img src="@/assets/q1.png"/></span><span class="texts">{{ $t('common.seat') }}</span>
                  </div>
                  <div class="right_text">
                    <span>
<!--                      {{ // $t('common.person.remainG', {count: mailWorkPosition.freePosition}) }}-->
                      {{ mailWorkPosition?.freePosition }}/<span style="color: red">
                        {{ mailWorkPosition?.totalPosition }} {{ $t('common_ph22') }}
                      </span>
                    </span>
                    <el-icon>
                      <ArrowRightBold/>
                    </el-icon>
                  </div>
                </div>
              </el-dropdown-item>
              <!--              存储-->
              <el-dropdown-item @click="goToStoreDetails">
                <div class="items">
                  <div class="left_text">
                    <span><img src="@/assets/q2.png"></span><span class="texts">{{ $t('common.space') }}</span>
                  </div>
                  <div class="right_text">
                    <span> {{
                        spaceSizeFormat(spaceSize?.freeLocation || 0, false)
                      }}/<span style="color: red">{{ spaceSizeFormat(spaceSize?.effectiveLocation || 0) }}</span></span>
                    <el-icon>
                      <ArrowRightBold/>
                    </el-icon>
                  </div>
                </div>
              </el-dropdown-item
              >
              <!--              EDM-->
              <el-dropdown-item @click="goToStoreEDM">
                <div class="items">
                  <div class="left_text">
                    <span><img src="@/assets/edm.png" style="width: 16px;height: 16px;"></span><span
                      class="texts">{{ $t('userinfo.vip.edm') }}</span>
                  </div>
                  <div class="right_text">
                    <span>{{
                        userDataInformation?.freeEdmNum ? userDataInformation?.freeEdmNum : 0
                      }}/<span style="color: red">
                      {{
                          $t('userinfo.edm.number', {number: userDataInformation?.edmTotalNum ? userDataInformation?.edmTotalNum : 0})
                        }}</span></span>
                    <el-icon>
                      <ArrowRightBold/>
                    </el-icon>
                  </div>
                </div>
              </el-dropdown-item
              >
              <el-dropdown-item @click="goToStoreAI">
                <div class="items">
                  <div class="left_text">
                    <span><img src="@/assets/AI.png" style="width: 16px;height: 16px;"></span><span
                      class="texts">{{ $t('userinfo.vip.AI') }}</span>
                  </div>
                  <div class="right_text">
                    <span> {{
                        userDataInformation?.freeAiNum ? userDataInformation?.freeAiNum : 0
                      }}/<span style="color: red">{{
                          $t('userinfo.AI.number', {number: userDataInformation?.totalAiNum ? userDataInformation?.totalAiNum : 0})
                        }}</span></span>
                    <el-icon>
                      <ArrowRightBold/>
                    </el-icon>
                  </div>
                </div>
              </el-dropdown-item
              >
              <el-dropdown-item v-if="isNormalUser||isEnterpriseMainUser" @click="handleClickJoinVip">
                <div class="items"
                     style="display: flex;flex-direction: column;align-items: flex-start;justify-content: center;height: max-content!important;">
                  <div class="item_title">{{ $t('header.down.user') }}</div>
                  <div class="inner_box_vip">
                    <template v-if="isVipUser">
                      <span>
                        <span style="margin-right: 5px;">{{ $t('join.have') }}</span>
                        <span style="color: #D93737" v-if="userInfo.isVip===1">{{ $t('vip.type.1') }}</span>
                        <span style="color: #D93737" v-else-if="userInfo.isVip===2">{{ $t('vip.type.2') }}</span>
                        <span style="color: #D93737" v-else-if="userInfo.isVip===3">{{ $t('vip.type.3') }}</span>
                      </span>
                      <span v-if="userInfo?.vipExpireDate">，{{ $t('vip.expire.date', {date: userInfo?.vipExpireDate}) }}&nbsp;&nbsp;</span>
                      <span v-else>，{{ $t('common.yjmf') }}</span>
                      <span v-if="userInfo.isVip!==3" style="color: #0073FF">{{ $t('vip.up') }}</span>
                    </template>
                    <template v-else>
                      <span style="color: #0073FF">{{ $t('join.vip') }}</span>
                      <span>，{{ $t('join.vip.des') }}</span>
                    </template>
                  </div>
                </div>
              </el-dropdown-item
              >
              <!--              分割线-->
              <el-dropdown-item @click="goToSetting">
                <div class="items">
                  <div class="left_text">
                    <span class="sp_out"><img height="18" src="@/assets/usercenter/setting.svg"/></span><span
                      class="texts">{{ $t('common.setting') }}</span>
                  </div>
                  <div class="right_text">
                    <el-icon>
                      <ArrowRightBold/>
                    </el-icon>
                  </div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item @click="goToRepairOrder">
                <div class="items">
                  <div class="left_text">
                    <span class="sp_out"><img height="18" src="@/assets/usercenter/message.svg"/></span><span
                      class="texts">{{ $t('common.cds42') }}</span>
                  </div>
                  <div class="right_text">
                    <el-icon>
                      <ArrowRightBold/>
                    </el-icon>
                  </div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item @click="handleLogout">
                <div class="items">
                  <div class="left_text">
                    <span class="sp_out"><img height="18" src="@/assets/usercenter/signout.svg"/></span><span
                      class="texts">{{ $t('common.exit') }}</span>
                  </div>
                  <div class="right_text">
                    <el-icon>
                      <ArrowRightBold/>
                    </el-icon>
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <div data-v-2b3b0c9a="" style="width: 50px"></div>
      </div>
    </div>
    <CreateTeamPop v-if="visitable" v-model="visitable" @close="close"/>
    <Dialog
        v-model="dialogVisibleTips"
        :title="$t('sys.team.info')"
        :width="'400'"
        :dialogVisible="dialogVisibleTips"
        :isHeadLine="false"
        @update:dialogVisible="(val) => (dialogVisibleTips = val)"
    >
      <template #content>
        <div class="inners_warning">
          <div>
            <el-icon style="font-size: 25px;color: #448ef7">
              <Warning/>
            </el-icon>
          </div>
          <div style="font-size: 14px;">{{ $t('common.p2h4') }}</div>
        </div>
      </template>
      <template #footer>
        <div class="setting_center">
          <el-button type="primary" @click="dialogVisibleTips = false">{{ $t('common.data.know') }}</el-button>
        </div>
      </template>
    </Dialog>
  </div>

  <!--  侧边栏 AI-->
  <el-drawer
      v-model="drawer"
      :size="'32%'"
      style="max-width: 800px !important;min-width: 450px !important;"
      :with-header="false"
      :modal-append-to-body="false"
      :modal="false"
      modal-class="chatAIDrawer"
      custom-class="custom-drawer"
      :mask-click-close="false"
  >
    <AICom @closeAIChat="handleClickCloseChat"/>
  </el-drawer>
</template>
<script>
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import {useStore} from "vuex";
import home from "@/assets/img/tab/home.png";
import homeB from "@/assets/img/tab/home-b.png";
import email from "@/assets/img/tab/email.png";
import emailB from "@/assets/img/tab/email-b.png";
import wechat from "@/assets/img/tab/wechat.jpg"
import wechatB from "@/assets/img/tab/wechatB.jpg"
import file from "@/assets/img/tab/file.png";
import fileB from "@/assets/img/tab/file-b.png";
import {useRoute, useRouter} from "vue-router";
import CreateTeamPop from "../DiaPops/CreateTeamPop.vue";
import Dialog from "@/components/Dialog.vue";
import {ArrowRightBold, Back, Select} from "@element-plus/icons-vue";

import {conMessage, tzIcons} from "@/utils/mes/messageMap";
import Message from "@/components/Message"
import {ElMessage} from "element-plus";
import {spaceSizeFormat} from "../../utils/file";
import Chat from '../Chat/index.vue';
import {i18n} from "@/lang";
import AICom from "@/components/AI/index.vue"
import {isEmpty} from "@/utils/mylodash";
import {Storage} from "@/utils/storage";

const store = useStore();

export default {
  computed: {
    Select() {
      return Select
    }
  },
  methods: {spaceSizeFormat},
  components: {ArrowRightBold, Back, Dialog, CreateTeamPop, Message, Chat, AICom},
  setup() {
    const userInfo = computed(() => store.state.user.userInfo);
    const isEnterpriseMainUser = computed(() => store.getters["user/isEnterpriseMainUser"])
    const isEnterpriseChildUser = computed(() => store.getters["user/isEnterpriseChildUser"])
    const isNormalUser = computed(() => store.getters["user/isNormalUser"])
    // 工位信息
    const dialogVisibleTips = ref(false);
    const mailWorkPosition = computed(() => store.state.user.mailWorkPosition)
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const visitable = ref(false);
    // 是否是vip
    const isVip = computed(() => store.getters['user/isVipAccount'])
    const isVipUser = computed(() => store.getters['user/isVipUser'])
    // vip 类型
    const vipType = computed(() => userInfo.value.isVip)
    console.log(vipType, 'vipType')
    // 侧边栏 draw
    const drawer = ref(false)
    const teamList = computed(() => store.state.email.teamList);
    const teamId = computed(() => store.state.email.teamID)
    const tabPath = computed(() => {
      const path = route.path.split("/")[1];
      return `/${path}`;
    });

    const EMAIL_UNREAD_DOT_STORAGE_KEY = 'email_unread_dot'
    const EMAIL_WS_UNREAD_COUNT_STORAGE_KEY = 'email_ws_unread_count'
    const EMAIL_BADGE_LAST_SEEN_TOTAL_STORAGE_KEY = 'email_badge_last_seen_total'
    const emailUnreadDot = ref(false)
    const emailWsUnreadCount = ref(0)
    const emailBadgeLastSeenTotal = ref(0)

    const readEmailUnreadDotCache = () => {
      try {
        return localStorage.getItem(EMAIL_UNREAD_DOT_STORAGE_KEY) === '1'
      } catch (e) {
        return false
      }
    }

    const clearEmailUnreadDot = () => {
      emailUnreadDot.value = false
      try {
        localStorage.removeItem(EMAIL_UNREAD_DOT_STORAGE_KEY)
      } catch (e) {
      }
    }

    const readEmailWsUnreadCountCache = () => {
      try {
        const raw = localStorage.getItem(EMAIL_WS_UNREAD_COUNT_STORAGE_KEY)
        const n = Number(raw || 0)
        return Number.isFinite(n) ? n : 0
      } catch (e) {
        return 0
      }
    }

    const clearEmailWsUnreadCount = () => {
      emailWsUnreadCount.value = 0
      try {
        localStorage.removeItem(EMAIL_WS_UNREAD_COUNT_STORAGE_KEY)
      } catch (e) {
      }
    }

    const readEmailBadgeLastSeenTotalCache = () => {
      try {
        const raw = localStorage.getItem(EMAIL_BADGE_LAST_SEEN_TOTAL_STORAGE_KEY)
        const n = Number(raw || 0)
        return Number.isFinite(n) ? n : 0
      } catch (e) {
        return 0
      }
    }

    const writeEmailBadgeLastSeenTotalCache = (n) => {
      try {
        localStorage.setItem(EMAIL_BADGE_LAST_SEEN_TOTAL_STORAGE_KEY, String(Number(n || 0)))
      } catch (e) {
      }
    }

    const handleEmailUnreadDot = (event) => {
      const hasUnread = Boolean(event?.detail?.hasUnread)
      if (hasUnread) emailUnreadDot.value = true
    }

    const handleEmailWsUnreadCount = (event) => {
      const count = Number(event?.detail?.count ?? 0)
      emailWsUnreadCount.value = Number.isFinite(count) ? count : 0
    }

    const allTeamStatisticsList = computed(() => store.state.countshow?.allEmailList || [])
    const emailStatisticsCount = computed(() => {
      const list = Array.isArray(allTeamStatisticsList.value) ? allTeamStatisticsList.value : []
      const targetKeys = new Set(['unReadCount', 'auditCount', 'failCount', 'followCount', 'receiveCount'])
      return list
          .filter(it => it && targetKeys.has(it.key))
          .reduce((sum, it) => sum + Number(it.count || 0), 0)
    })

    const emailBadgeCurrentTotal = computed(() => {
      return Number(emailStatisticsCount.value || 0) + Number(emailWsUnreadCount.value || 0)
    })

    const emailHasBadgeDot = computed(() => {
      return Number(emailBadgeCurrentTotal.value || 0) > Number(emailBadgeLastSeenTotal.value || 0)
    })

    const teamSumDataLoading = computed(() => store.state.countshow?.teamSumDataLoading)
    const teamSumDataLoadedTeamId = computed(() => store.state.countshow?.teamSumDataLoadedTeamId)
    const emailBadgeReady = computed(() => {
      const curTeamId = teamId.value == null ? '' : String(teamId.value)
      if (!curTeamId) return false
      return !teamSumDataLoading.value && String(teamSumDataLoadedTeamId.value || '') === curTeamId
    })
    const emailBadgeDotVisible = computed(() => {
      return emailBadgeReady.value && emailHasBadgeDot.value
    })

    const refreshTeamSumData = async (id) => {
      const cur = id == null ? '' : String(id)
      if (!cur) return
      try {
        store.commit('countshow/setTeamSumDataLoadedTeamId', '')
        store.commit('countshow/setTeamSumDataLoading', true)
      } catch (e) {
      }
      try {
        await store.dispatch('countshow/getTeamSumDataApis', {teamId: cur})
      } catch (e) {
      }
    }

    const waBadgeCount = ref(0)
    const WA_LOGIN_STORAGE_KEY = 'wa_login_user'
    const waIsLogin = ref(false)

    const checkWaIsLogin = () => {
      try {
        const user = Storage.get(WA_LOGIN_STORAGE_KEY)
        waIsLogin.value = !!(user && user.id && (user.name || user.pushName))
      } catch (e) {
        waIsLogin.value = false
      }
    }

    watch(waIsLogin, (val) => {
      if (!val) {
        waBadgeCount.value = 0
      }
    })

    watch(tabPath, () => {
      checkWaIsLogin()
    })
    const readWaUnreadCache = () => {
      try {
        const raw = localStorage.getItem('wa_unread_map')
        const parsed = raw ? JSON.parse(raw) : {}
        return parsed && typeof parsed === 'object' ? parsed : {}
      } catch (e) {
        return {}
      }
    }

    const writeWaUnreadCache = (cache) => {
      try {
        localStorage.setItem('wa_unread_map', JSON.stringify(cache || {}))
      } catch (e) {
      }
    }

    const stripWaIdSuffix = (v) => {
      const s = String(v || '').trim()
      if (!s) return ''
      return s.replace(/@.*$/, '')
    }

    const isSameWaChat = (a, b) => {
      const x = String(a || '').trim()
      const y = String(b || '').trim()
      if (!x || !y) return false
      if (x === y) return true
      const bx = stripWaIdSuffix(x)
      const by = stripWaIdSuffix(y)
      if (bx && by && bx === by) return true
      if (bx) {
        if (`${bx}@c.us` === y || `${bx}@lid` === y || `${bx}@g.us` === y) return true
      }
      if (by) {
        if (`${by}@c.us` === x || `${by}@lid` === x || `${by}@g.us` === x) return true
      }
      return false
    }

    const getGlobalWaHandledMessageIds = () => {
      try {
        if (!window.__waHandledMessageIds) {
          window.__waHandledMessageIds = new Map()
        }
        return window.__waHandledMessageIds
      } catch (e) {
        return null
      }
    }

    const markWaMessageHandled = (messageId) => {
      const mid = String(messageId || '').trim()
      if (!mid) return false

      const STORAGE_KEY = 'wa_handled_message_ids'
      const TTL_MS = 10 * 60 * 1000
      const MAX = 300

      try {
        const raw = localStorage.getItem(STORAGE_KEY)
        const arr = raw ? JSON.parse(raw) : []
        const now = Date.now()
        const next = Array.isArray(arr) ? arr.filter(it => it && typeof it.id === 'string' && typeof it.ts === 'number' && now - it.ts < TTL_MS) : []
        if (next.some(it => it.id === mid)) {
          return false
        }
        next.push({ id: mid, ts: now })
        if (next.length > MAX) {
          next.splice(0, next.length - MAX)
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
      } catch (e) {
      }

      const map = getGlobalWaHandledMessageIds()
      if (!map || typeof map.has !== 'function') return true

      const now = Date.now()
      try {
        for (const [k, ts] of map.entries()) {
          if (typeof ts === 'number' && now - ts > 5 * 60 * 1000) {
            map.delete(k)
          }
        }
      } catch (e) {
      }

      if (map.has(mid)) return false
      map.set(mid, now)
      return true
    }

    const handleWaPushMessage = (event) => {
      const detail = event?.detail || {}
      const hasMessageId = !!String(detail?.messageId || '').trim()

      if (hasMessageId) {
        const ok = markWaMessageHandled(detail?.messageId)
        if (!ok) return
      }

      const rawCount = Number(detail?.count ?? detail?.badgeCount)
      const providedCount = Number.isFinite(rawCount) ? rawCount : null

      if (!hasMessageId && typeof providedCount === 'number') {
        waBadgeCount.value = providedCount
        return
      }

      const inc = typeof providedCount === 'number' ? providedCount : 1

      try {
        const activeRoomId = String(window.__waActiveRoomId || '').trim()
        const from = String(detail?.from || detail?.fromJid || detail?.sender || detail?.chatFrom || '').trim()
        const pushedChatId = String(detail?.chatId || '').trim()
        const compareId = from || pushedChatId
        if (activeRoomId && compareId && isSameWaChat(compareId, activeRoomId)) {
          return
        }
      } catch (e) {
      }

      waBadgeCount.value = Number(waBadgeCount.value || 0) + inc

      const chatId = String(detail?.chatId || '').trim()
      if (chatId) {
        const cache = readWaUnreadCache()
        cache[chatId] = Number(cache[chatId] || 0) + inc
        writeWaUnreadCache(cache)
      }
    }

    const handleWaUnreadTotal = (event) => {
      const total = Number(event?.detail?.total ?? event?.detail?.count ?? 0)
      const next = Number.isFinite(total) ? total : 0
      waBadgeCount.value = next

      if (next === 0) {
        try {
          localStorage.removeItem('wa_unread_map')
        } catch (e) {
        }
      }
    }

    const retainGlobalEventListener = (key, eventName, handler) => {
      try {
        const k = `__global_listener_refs_${key}`
        const refs = Number(window[k] || 0)
        if (refs <= 0) {
          window.addEventListener(eventName, handler)
          window[k] = 1
        } else {
          window[k] = refs + 1
        }
      } catch (e) {
        try {
          window.addEventListener(eventName, handler)
        } catch (e2) {
        }
      }
    }

    const releaseGlobalEventListener = (key, eventName, handler) => {
      try {
        const k = `__global_listener_refs_${key}`
        const refs = Number(window[k] || 0)
        const next = refs - 1
        if (next <= 0) {
          window.removeEventListener(eventName, handler)
          window[k] = 0
        } else {
          window[k] = next
        }
      } catch (e) {
        try {
          window.removeEventListener(eventName, handler)
        } catch (e2) {
        }
      }
    }


    // 通知图标类型

    // heander 最新消息
    const newData = computed(() => store.state.message.newData)
    const resultTargetDataList = computed(() => {
      if (newData.value.length !== 0) {
        return conMessage(newData.value);
      } else {
        return newData.value;
      }
    })


    const visible = ref(false);
    const dropdownRef = ref(null);

    function toggleDropdown(event) {
      console.log(111);
      visible.value = !visible.value;
      event.stopPropagation();
    }

    function handleClick() {
      visible.value = false;
    }


    const tabList = ref([
      {
        src: home,
        srcb: homeB,
        path: "/dashboard",
        query: {},
      },
      {
        src: email,
        srcb: emailB,
        path: `/email`,
        cacheName: "",
        query: {},
        params: {
          teamId: teamId.value,
        },
      },
      {
        src: file,
        srcb: fileB,
        path: "/cloud",
        cacheName: "",
        query: {},
        params: {pg: "f"},
      },
      {
        src: wechat,
        srcb: wechatB,
        path: "/whatsapp",
        cacheName: "",
        query: {},
        params: {pg: "f"}
      }
    ]);

    // 通知
    function toAllNotify() {
      closeDropdownRef()
      openNewTab('/notificationList/systemNotification')
    }

    const openNewTab = (path, query = {}) => {
      const routeInfo = router.resolve({path, query});
      window.open(routeInfo.href, '_blank');
    };

    const isReadAllLoading = ref(false)
    const handleClickIsRead = async () => {
      if (resultTargetDataList.value.length === 0) {
        ElMessage.warning(i18n.global.t('sys.notice.unread'));
        return
      }
      isReadAllLoading.value = true
      try {
        await store.dispatch("message/isReadAllApis")
        await store.dispatch("message/getUnReadMessageListApisDefault", {pageNo: 1, pageSize: 999})
        await store.dispatch("message/getUnReadMessageListApis", {pageNo: pageNo.value, pageSize: pageSize.value})
        isReadAllLoading.value = false
      } catch (e) {
        isReadAllLoading.value = false
      }
    }

    // async function tabChange(item) {
    //   console.log('fff', item, item.path, isEnterpriseChildUser.value, teamList.value)
    //
    //   if (item.path === `/email` && isEnterpriseChildUser.value && teamList.value.length === 0) {
    //     dialogVisibleTips.value = true;
    //     return
    //   }
    //   if (item.path === `/email` && !isEnterpriseChildUser.value && teamList.value.length === 0) {
    //     visitable.value = true;
    //     return;
    //   }
    //   // 路由初始化控制
    //   if (item.path === `/email`) {
    //     // const targetRouter = localStorage.getItem('activeMenu') == null || localStorage.getItem("activeMenu") == "/email/account_setting" ? '/email/inbox' : localStorage.getItem('activeMenu')
    //
    //     //找到目标 团队 看是否已经失效
    //     const targetTeam = teamList.value.find(it => it.id === item.params.teamId) || {expireTime: null}
    //     console.log(targetTeam, 'fff')
    //     let targetRouter = `/email/inbox`
    //     const time = targetTeam.expireTime;
    //     if (time === null) {
    //       // 永久有效
    //       await store.commit("email/setShouldShowSideBar", true)
    //       targetRouter = `/email/inbox`
    //     } else {
    //       const timeTemp = new Date(time).getTime();
    //       const now = Date.now(); // 当前时间戳（毫秒）
    //
    //       if (timeTemp > now) {
    //         // 还在有效期内，正常处理
    //         await store.commit("email/setShouldShowSideBar", true)
    //         targetRouter = `/email/inbox`
    //       } else {
    //         // 已过期，无效
    //         await store.commit("email/setShouldShowSideBar", false)
    //         targetRouter = `/email/systemPrompt`
    //       }
    //     }
    //     console.log('targetRouter', targetRouter)
    //     router.replace(targetRouter);
    //   } else {
    //     router.replace(item.path);
    //   }
    //   // 更新权限
    //   await store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value, isUpdate: true})
    // }

    async function tabChange(item) {
      console.log('fff', item, item.path, isEnterpriseChildUser.value, teamList.value);

      // ① 特殊场景拦截
      if (item.path === `/email`) {
        clearEmailUnreadDot()
        if (isEnterpriseChildUser.value && teamList.value.length === 0) {
          dialogVisibleTips.value = true;
          return;
        }
        if (!isEnterpriseChildUser.value && teamList.value.length === 0) {
          visitable.value = true;
          return;
        }
      }

      // ② email 模块特殊路由处理
      if (item.path === `/email`) {
        const targetTeam = teamList.value.find(it => it.id === teamId.value);
        console.log(targetTeam, 'targetTeam')
        const targetRouter = getEmailTargetRoute(targetTeam);

        console.log('targetRouter', targetRouter);

        router.replace(targetRouter);
      } else {
        router.replace(item.path);
      }

      // ③ 刷新权限信息（放在路由跳转之后）
      try {
        await store.dispatch("user/checkUserInfoIsAdmin", {
          teamId: teamId.value,
          isUpdate: true
        });
      } catch (error) {
        console.error("权限刷新失败:", error);
      }
    }


    /** ----------------------------
     * 抽离出：判断 email 模块跳转路径
     * ---------------------------- */
    function getEmailTargetRoute(targetTeam) {
      if (!targetTeam || targetTeam.expireTime == null) {
        // 没团队 || 永不过期
        store.commit("email/setShouldShowSideBar", true);
        return `/email/inbox`;
      }

      const expire = new Date(targetTeam.expireTime).getTime();
      const now = Date.now();

      if (expire > now) {
        // 有效期内
        store.commit("email/setShouldShowSideBar", true);
        return `/email/inbox`;
      } else {
        // 团队已过期
        store.commit("email/setShouldShowSideBar", false);
        return `/email/systemPrompt?teamId=${targetTeam.id}&workPositionId=${targetTeam.workPositionId}`;
      }
    }

    function close() {
      visitable.value = false;
    }

    const pageNo = ref(1);
    const pageSize = ref(5);

    const flagNumbers = computed(() => {
      if (newData.value.length > pageSize.value) {
        return allDataTotal.value
      } else {
        return newData.value.length
      }
    })

    const allDataTotal = computed(() => store.state.message.allNewData)
    const isBottom = ref(false)
    const allNewDataIsLoading = computed(() => store.state.message.allNewDataIsLoading)
    const changePage = async () => {
      const startIndex = (pageNo.value - 1) * pageSize.value; // 计算当前页的起始索引
      const endIndex = Math.min(startIndex + pageSize.value, allDataTotal.value); // 计算当前页的结束索引
      console.log(endIndex, allDataTotal.value, 'fff')
      if (endIndex >= allDataTotal.value) {
        // ElMessage.warning("已经到底了")
        isBottom.value = true;
        return
      }
      pageNo.value = pageNo.value + 1;
      // 需要更新数据
      await store.dispatch("message/getUnReadMessageListApis", {pageNo: pageNo.value, pageSize: pageSize.value})
    }

    const getUnReadsList = async () => {
      await store.commit("message/resetNewData", [])
      // 需要更新数据
      await store.dispatch("message/getUnReadMessageListApis", {pageNo: pageNo.value, pageSize: pageSize.value})
    }


    onMounted(async () => {
      await store.dispatch('email/getTeamList', {isUpdate: true})
      await store.dispatch("user/getPositionByLoginList");
      // 所有消息的
      // await store.dispatch("message/getMessageListApis", {pageNo: pageNo.value, pageSize: pageSize.value})
      // 获取最新未读消息
      // 展示数据即可
      await store.dispatch("message/getUnReadMessageListApis", {pageNo: pageNo.value, pageSize: pageSize.value})
      console.log(route.path.split("/"), "route", tabPath);

      try {
        const cache = readWaUnreadCache()
        const total = Object.values(cache || {}).reduce((sum, v) => sum + Number(v || 0), 0)
        waBadgeCount.value = Number.isFinite(total) ? total : 0
      } catch (e) {
      }

      checkWaIsLogin()

      try {
        emailUnreadDot.value = readEmailUnreadDotCache()
      } catch (e) {
      }

      try {
        emailWsUnreadCount.value = readEmailWsUnreadCountCache()
      } catch (e) {
      }

      try {
        emailBadgeLastSeenTotal.value = readEmailBadgeLastSeenTotalCache()
      } catch (e) {
      }

      try {
        retainGlobalEventListener('wa-push-message', 'wa-push-message', handleWaPushMessage)
      } catch (e) {
      }

      try {
        window.addEventListener('email-unread-dot', handleEmailUnreadDot)
      } catch (e) {
      }

      try {
        window.addEventListener('email-ws-unread-count', handleEmailWsUnreadCount)
      } catch (e) {
      }

      try {
        retainGlobalEventListener('wa-unread-total', 'wa-unread-total', handleWaUnreadTotal)
      } catch (e) {
      }

      document.addEventListener('click', closeHandleClick, {
        capture: true
      })

      try {
        retainGlobalEventListener('storage-check-wa-login', 'storage', checkWaIsLogin)
      } catch (e) {
      }
    });
    onUnmounted(() => {
      try {
        releaseGlobalEventListener('wa-push-message', 'wa-push-message', handleWaPushMessage)
      } catch (e) {
      }

      try {
        window.removeEventListener('email-unread-dot', handleEmailUnreadDot)
      } catch (e) {
      }

      try {
        window.removeEventListener('email-ws-unread-count', handleEmailWsUnreadCount)
      } catch (e) {
      }

      try {
        releaseGlobalEventListener('wa-unread-total', 'wa-unread-total', handleWaUnreadTotal)
      } catch (e) {
      }
      document.removeEventListener('click', closeHandleClick)

      try {
        releaseGlobalEventListener('storage-check-wa-login', 'storage', checkWaIsLogin)
      } catch (e) {
      }
    })

    watch(tabPath, (val) => {
      if (val === '/email') {
        clearEmailUnreadDot()
        emailBadgeLastSeenTotal.value = Number(emailBadgeCurrentTotal.value || 0)
        writeEmailBadgeLastSeenTotalCache(emailBadgeLastSeenTotal.value)
      }
    })

    watch(emailBadgeCurrentTotal, (val) => {
      const current = Number(val || 0)
      const lastSeen = Number(emailBadgeLastSeenTotal.value || 0)
      if (current < lastSeen) {
        emailBadgeLastSeenTotal.value = current
        writeEmailBadgeLastSeenTotalCache(current)
      }
    })

    watch(teamId, async (val) => {
      await refreshTeamSumData(val)
    }, {immediate: true})

    const closeHandleClick = (event) => {
      if (!event.target.closest('.dropdown-menu')) {
        visible.value = false;
      }
    }

    function goToUserCenter() {
      router.push(isEnterpriseMainUser.value ? '/personal/qinfo' : '/personal/basic')
    }

    function goToStation() {
      if (isEnterpriseMainUser.value || isNormalUser.value) {
        router.push('/personal/station')
      }
    }

    function goToStoreDetails() {
      if (isNormalUser.value) {
        router.push('/personal/storeDetails')
      } else {
        router.push('/personal/basic?active=1')
      }
    }

    function goToStoreEDM() {
      if (isNormalUser.value) {
        router.push("/personal/edmDetails")
      } else {
        router.push('/personal/basic?active=2')
      }
    }

    function goToStoreAI() {
      if (isNormalUser.value) {
        router.push("/personal/aiDetails")
      } else {
        router.push('/personal/basic?active=3')
      }
    }

    function goToSetting() {
      router.push('/personal/security')
    }

    function goToRepairOrder() {
      router.push('/personal/repairOrder')
    }

    // 退出登陆
    async function handleLogout() {
      await store.dispatch('user/UserQuit')
      await store.dispatch('chat/logout')
      router.push('/login')
    }


    /**
     * 文件存储的空间大小
     */
    const spaceSize = computed(() => store.state.cloud.spaceSize)
    const userDataInformation = computed(() => store.state.cloud.userDataInformation)
    onMounted(async () => {
      if (isEmpty(spaceSize.value)) {
        await store.dispatch("cloud/queryByUserIdApis")
      }
    })
    const handleClickCloseChat = () => {
      drawer.value = false
    }

    const closeDropdownRef = () => {
      dropdownRef.value?.handleClose?.()
    }


    const formattedMessage = computed(() => {
      const message = i18n.global.t("common.person.remainG", {
        count: mailWorkPosition.value.freePosition
      })
      return message
    })

    const handleClickJoinVip = () => {
      if (isNormalUser.value) {
        router.push('/personal/basic')
      } else if (isEnterpriseMainUser.value) {
        router.push('/personal/qinfo')
      }
    }

    return {
      isVipUser,
      userDataInformation,
      vipType,
      handleClickJoinVip,
      isVip,
      isEnterpriseMainUser,
      isNormalUser,
      goToStoreAI,
      goToStoreEDM,
      formattedMessage,
      isReadAllLoading,
      closeDropdownRef,
      handleClickCloseChat,
      spaceSize,
      getUnReadsList,
      flagNumbers,
      allNewDataIsLoading,
      allDataTotal,
      isBottom,
      changePage,
      resultTargetDataList,
      newData,
      handleClickIsRead,
      tabList,
      tabPath,
      tabChange,
      teamId,
      close,
      visitable,
      goToUserCenter,
      goToStation,
      goToStoreDetails,
      goToSetting,
      goToRepairOrder,
      handleLogout,
      userInfo, mailWorkPosition,
      dialogVisibleTips,
      toAllNotify,
      dropdownRef,
      visible,
      handleClick,
      toggleDropdown,
      drawer,
      emailUnreadDot,
      emailWsUnreadCount,
      emailBadgeLastSeenTotal,
      emailHasBadgeDot,
      emailBadgeDotVisible,
      waIsLogin,
      waBadgeCount,
    };
  },
};
</script>
<style lang="less" scoped>
@import "./less/Header.less";

.wa-tab-badge {
  position: relative;
  display: inline-block;
  line-height: 0;
}

.email-tab-badge {
  position: relative;
  display: inline-block;
  line-height: 0;
}



.left_text {
  span {
    display: inherit;
    margin-right: 8px;

    img {
      text-align: center;
    }
  }
}

.right_text {
  display: flex;
  align-items: center;
}

.sp_out {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #eef1f3;
  position: relative;

  & > img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

:deep(.el-dropdown-menu__item) {
  transition: all .3s;
}

:deep(.el-dropdown-menu__item:not(.is-disabled):focus) {
  background: #f9f9f9;
  color: #121212;
  transition: all .3s;
}

:deep(.el-dropdown-menu__item:nth-of-type(4):not(.is-disabled):focus) {
  background: transparent !important;

}

.inners_warning {
  display: flex !important;
  flex-direction: row !important;
  align-items: center;

  div {
    margin-left: 10px;
  }
}

.setting_center {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

:deep(.el-avatar) {
  cursor: pointer;
  background: #f3f3f3 !important;
}

.texts {
  color: #000000 !important;
}

.inner_notify_box {
  width: 350px;
  padding: 0 20px;
  background: #fff;
}

.boxs {
  width: 350px;
  min-width: 350px;
  height: auto;
  max-height: 540px !important;

  .empty {
    padding-top: 50px;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    color: rgba(0, 0, 0, .65);
    font-size: 14px;
  }

  .item_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    align-items: center;
    z-index: 9;
    bottom: 0px;
    width: 100%;
    background: white;
  }

  .tops_side {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px 15px;
    position: absolute;
    top: 0px;
    width: 100%;
    background: white;

    .top_message {
      font-size: 18px;
      line-height: 18px;
      font-weight: 600;
      color: #333;
    }
  }
}

.inner_boxs {
  min-height: 106px;
  margin-top: 50px;
  margin-bottom: 30px;
}


:deep(.el-badge__content) {
  position: absolute;
  right: calc(-8px + var(--el-badge-size) / 2) !important;
  top: -40px !important;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  // background-color: red;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 10px;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}


/* 定义淡入淡出动画 */
.fade-enter-active, .fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  transform: translate(-50%, -10px);
  opacity: 0;
}

.fade-enter-to, .dropdown-leave-from {
  opacity: 1;
  transform: translate(-50%, 0);
}


//:deep(.el-drawer){
//  position: relative;
//  left: 100vw;
//  margin-top: 87px;
//  width: 30vw !important;
//  height: 100vh !important;
//}

.custom-drawer {
  pointer-events: none !important; /* 禁止抽屉整体的点击穿透 */
}

:deep(.dropdown-trigger) {
  display: flex;
  justify-content: center;
  align-items: center;
}

.items_message {
  position: absolute;
  top: 36px;
  left: 48px;
}

:deep(.el-menu-item *) {
  vertical-align: middle !important;
}

.item_title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: black;
}

.inner_box_vip {
  margin-top: 10px;
  padding: 6px;
  margin-bottom: 10px;
  height: max-content;
  width: 100%;
  background: #F4F5F7;

  & > span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    white-space: break-spaces;
    color: #333333;
  }
}

:deep(.wa-tab-badge .el-badge__content) {
    top: -6px !important;
    right: -12px !important;
    z-index: 9999;
}

:deep(.email-tab-badge .el-badge__content) {
  top: -6px !important;
  right: -8px !important;
  z-index: 9999;
}
:deep(.el-badge__content.is-dot){
    width: 15px !important;
    height: 15px !important
}
</style>
